import { EVENT_TYPE_LABELS_PT } from "@/features/tracking/constants/events";
import type { EventTypeCode } from "@/features/tracking/types/events";
import api from "@/services/api";
import type {
	EventsMetrics,
	EventsMetricsApiResponse,
	EventsMetricsParams,
} from "../types/events-metrics";

const SPEEDING_IN_RAIN_EVENT_TYPE = 11;

function normalizeItems(
	raw: Record<string, number> | undefined
): Partial<Record<EventTypeCode, number>> {
	if (!raw) {
		return {};
	}
	const out: Partial<Record<EventTypeCode, number>> = {};
	for (const [key, count] of Object.entries(raw)) {
		const code = Number(key);
		if (
			!(Number.isFinite(code) && code in EVENT_TYPE_LABELS_PT) ||
			code === SPEEDING_IN_RAIN_EVENT_TYPE
		) {
			continue;
		}
		out[code as EventTypeCode] = count;
	}
	return out;
}

export async function getEventsMetrics(
	params: EventsMetricsParams
): Promise<EventsMetrics> {
	const { data } = await api.get<EventsMetricsApiResponse>(
		"/api/event/metrics",
		{
			params: {
				StartDate: params.startDate,
				EndDate: params.endDate,
			},
		}
	);

	const excludedCount = Number(data?.items?.[SPEEDING_IN_RAIN_EVENT_TYPE]) || 0;

	return {
		items: normalizeItems(data?.items),
		total: Math.max((data?.total ?? 0) - excludedCount, 0),
	};
}
